// COLLECTION OF VUE DIRECTIVES
import renderNodeEl from './parials/renderNodeEl.js';
import contentEditable from './parials/contentEditable.js';

const globalDirectives = {
    install(Vue) {
        Vue.directive('node', renderNodeEl);
        Vue.directive('meditable', contentEditable);
    }
}

export default globalDirectives;